<template>
  <div class="content if-profile report-tab">
    <div class="md-layout financal-report">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0"
      >
        <div class="md-layout">
          <SPIFReportHeader :headerData="this.headerData"/>

          <div class="md-layout-item md-size-100 p-0">
            <md-card>
              <!--
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-50">
                  <md-card-header class="md-card-header-icon">
                    <h1 class="md-title text-left profile-title">
                      Summary Scores<br />
                    </h1>
                  </md-card-header>
                </div>
              </div>
              -->
              <md-card-content class="negetive_margin p-0">
                <div class="md-layout">
                  <div
                    class="md-layout-item md-medium-size-100 md-size-50 summary-scores-box-star"
                  >
                    <table-card class="if_card">
                      <template slot="header" header-color="rose">
                        Summary Scores All Years
                        <!--
                        <div class="card-icon">
                          <md-icon>addchart</md-icon>
                        </div>
                        <h4 class=" Performance Scores">
                          <div class="md-layout-item md-medium-size-100 md-size-100 card-title">
                            Summary Scores(2015-2016-2017-2018-2019) (Scale 1-5)
                          </div>
                        </h4>
                        -->
                      </template>
                      <template slot="content">
                        <div class="extra_space">
                          <p>Based on your inputs, the Industry Financial Report calculates the percentage difference (variance) between client ratios and the industry average for the selected industry peer group. Your firm performance on each ratio is scored on a 1-5 scale (5 being best) for each year displayed in the report. The scoring approach depends on the specific scored ratio. You can find a detailed explanation for each at the end of this report.</p>
                          <p>The value of peer comparisons with your business depends on the accuracy and completeness of the firm financial information that is being entered. The more detail that you provide, the more comprehensive and meaningful the benchmark.</p>
                          <p>For each ratio, the score for those years selected from the most recent three calendar years is averaged and integrated into a Ratio Category Score. The Score for each of the four categories (Cash Flow/Solvency; Profitability; Efficiency; Debt-Risk) are then averaged to produce an Overall Score.</p>
                        </div>

                        <md-table
                          v-if="this.display_summary_scores"
                          v-model="summaryScoresAll"
                          table-header-color="blue"
                        >
                          <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                          >
                            <md-table-cell md-label>
                              {{ item.title }}
                            </md-table-cell>
                            <md-table-cell md-label>
                              {{ item.rating }}
                            </md-table-cell>
                            <md-table-cell
                              md-label
                              class="td-actions text-right"
                            >
                              <div class="md-button-content">
                                <md-icon
                                  v-for="(v, i) in getStars(item.rating)"
                                  :key="i + item.title"
                                  >{{ v }}</md-icon
                                >
                              </div>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </template>
                    </table-card>
                  </div>
                  <div v-if="worthYourFocus.length > 0" class="md-layout-item md-medium-size-100 md-size-50">
                    <profile-card header-color="blue" class="text-card if_card">
                      <template slot="header">Worth Your Focus (Scale 1-5)</template>
                      <template slot="content">
                        <md-table
                          v-model="worthYourFocus"
                          table-header-color="blue"
                          class="w-100"
                        >
                          <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                          >
                            <md-table-cell md-label>
                              {{ item.title }}
                            </md-table-cell>
                            <md-table-cell md-label>
                              {{ item.rating.toFixed(2) }}
                            </md-table-cell>
                             <md-table-cell
                              md-label
                              class="td-actions text-right"
                            >
                              <div class="md-button-content">
                                <md-icon
                                  v-for="(v, i) in getStars(item.rating)"
                                  :key="i + item.title"
                                  >{{ v }}</md-icon
                                >
                              </div>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </template>
                    </profile-card>
                  </div>
                  <div class="md-layout-item md-medium-size-100 md-size-50">
                    <profile-card header-color="blue" class="text-card if_card">
                      <template slot="header">Ratio Categories</template>
                      <template slot="content">
                        <div class="extra_space">
                          <p>The Bizminer Industry Financial Report is based on selected financial ratios that are typically considered to be Key Performance Indicators (KPIs) which includes:</p>
                          <p><b>Cash Flow/Solvency:</b> Cash Flow ratios indicate a company’s ability to meet various levels of demand on cash and easily obtainable cash resources against current and anticipated near-term payments due.</p>
                          <p><b>Profitability:</b> Profitability ratios compare levels of return against various expense and balance sheet components to measure your performance against reasonable industry peer group standards, indicating bottom line performance,</p>
                          <p><b>Efficiency:</b> Efficiency ratios measure your success in marshalling resources at hand to effectively manage various components of your business operations. These indicators often point most specifically toward actions that could enhance your bottom line.</p>
                          <p><b>Debt-Risk:</b> Debt-Risk ratios assess the appropriateness of a firm’s level of debt against the ability to pay, as well as the risk of insolvency.</p>
                          <br>
                          <h4>Worth Your Focus:</h4>
                          <p>Ratio Category scores are simply a reflection of the more focused individual ratios that they include. Any ratios that score below 3.0 should be examined closely for weaknesses in management or performance that could be improved with reasonable effort and expense. While you should work with a qualified advisor to obtain specific guidance, we’ve flagged these areas for attention:</p>
                        </div>
                      </template>
                    </profile-card>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TableCard, ProfileCard } from '@/components';
import ratingMixin from '@/mixins/rating-mixin';
import { mapState } from 'vuex';
import SPIFReportHeader from './_partials/SPIFHeader.vue';

export default {
  components: {
    SPIFReportHeader,
    TableCard,
    ProfileCard,
  },
  mixins: [ratingMixin],
  props: ['headerData'],
  data() {
    return {
      display_summary_scores: false,
      multipleBarsChart: {
        data: {
          labels: [ // TODO: make this automatic.
            'Jan 2019',
            'July 2019',
            'Jan 2020',
            'July 2020',
            'Jan 2021',
          ],
          series: [
            [0.8, 1.4, 1.8, 2.5, 2.2],
            [0.9, 1.3, 2.0, 2.8, 2.6],
            [1.1, 1.6, 2.3, 2.1, 3.0],
            [1.4, 1.2, 2.5, 2.2, 2.8],
            [1.2, 1.2, 2.8, 1.8, 2.4],
            [1.2, 1.7, 1.8, 1.9, 2.5],
          ],
        },
        options: {
          seriesBarDistance: 19,
          high: 4,
          axisX: {
            showGrid: false,
          },
          axisY: {
            offset: 80,
            labelInterpolationFnc: function(value) {
              return '$' + value + 'M';
            },
          },
          height: '150px',
        },
        responsiveOptions: [
          [
            'screen and (max-width: 640px)',
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
    };
  },
  computed: {
    ...mapState({
      worthYourFocus: (state) => state.user.report.data['worthYourFocus'],
      summaryScores: (state) => state.user.report.data['summaryScores'],
      report: (state) => state.user.report.data,
      activeSection: (state) => state.user?.activeSection,
      narrativeText: (state) => state.user?.report?.data?.narrativeText,
      BSText: (state) => state.user?.report?.data?.narrativeText?.BS,
      PLText: (state) => state.user?.report?.data?.narrativeText?.PL,
      SCText: (state) => state.user?.report?.data?.narrativeText?.SC,
      SUText: (state) => state.user?.report?.data?.narrativeText?.SU,
    }),
    summaryScoresAll() {
      if (this.summaryScores) {
        let k;
        if ('ratios' in this.summaryScores && this.summaryScores.ratios) {
          k = this.summaryScores.ratios;
        } else {
          k = '';
        }

        return [this.summaryScores.overall, ...Object.values(k)];
      } else {
        return '';
      }
    },
  },
  mounted() {
    if (
      this.report &&
      this.report.displaySettings &&
      this.report.displaySettings.includes('summary_scores')
    ) {
      this.display_summary_scores = true;
    }
  },
  methods: {
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Financial Report.csv';
      anchor.click();
    },
    getCsvData() {
      let csvData = [
        ['Industry Financial Report'],
        ['"Release Date"', this.release_display],
        [''],
        ['Segment', 'Industry'],
        [this.industry_title],
        ['[' + parseInt(this.bznaics_code) + ']' + ' Sector', this.sector_name],
        ['Market', this.display_area],
        ['Sales Class', this.sales_class_csv],
        [''],
      ];
      csvData.push(['Firms Analyzed', this.filtered_years]);
      csvData.push(['', this.filtered_firms]);
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss($)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss(%)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet($)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet(%)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Financial Ratios: Cash Flow-Solvency']);
      csvData.push(['', this.filtered_years]);
      this.cashFlowFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Profitability']);
      csvData.push(['', this.filtered_years]);
      this.profitabilityFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Efficiency']);
      csvData.push(['', this.filtered_years]);
      this.efficiencyFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Debt-Risk']);
      csvData.push(['', this.filtered_years]);
      this.debtRiskFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Sources & Uses of Funds']);
      csvData.push(['', this.sourceYears]);
      this.changeinFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['Worksheet:']);
      this.worksheetFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      return csvData;
    },
  },
};
</script>
<style lang="scss">
.financal-report {
  .financal-report-col-1 {
    display: flex;
    align-items: center;

    h4 {
      margin-top: 0;
    }
  }

  .heder-titel-col-2 {
    margin-bottom: 35px;

    .financal-report-col-3 {
      display: flex;
      justify-content: flex-end;
    }
  }

  .summary-scores-box-star {
    .md-button-content {
      .md-icon {
        color: #3b7ef1;
      }
    }

    h4 {
      margin-left: 60px;
    }
  }

  .summary-scores-box-flag {
    .md-icon {
      color: #3b7ef1;
    }

    .w-100 {
      width: 100%;
    }
  }
  .md-collapse-content {
    padding: 0 !important;
  }
  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }
}

.button-box {
  display: flex;
  justify-content: flex-end;
}

h4.main-street {
  padding-top: 0;
}
</style>
